import React, { useState, useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'
import PropType from 'prop-types';

TextEditor.propTypes = {
    content: PropType.string,
    setContent:  PropType.func,
    rawCharacterCount: PropType.number,
    setRawCharacterCount: PropType.func,
    maxAnnouncementCharacterCount: PropType.string,
    setHasPendingChange:  PropType.func
};
function TextEditor({content, setContent, rawCharacterCount, setRawCharacterCount, maxAnnouncementCharacterCount, setHasPendingChange}) {    
    const quillRef = useRef(null);
    const [previousState, setPreviousState] = useState({ id: null, enabled: false, content: null })

    const modules = {
        toolbar: {
            container: "#toolbar",
        }
    }

    const renderOptions = (formatData, j) => {
        const { className, options } = formatData;
        return (
            <select key={`select_${j}`} className={className}>
                <option></option>
                {
                    options.map((value, i) => {
                        return (
                            <option key={`format_${j}_${i}`} value={value}></option>
                        )
                    })
                }
            </select>
        )
    }
    const renderSingle = (formatData, j) => {
        const { className, value } = formatData;
        return (
            <button key={`format_${j}_0`} className={className} value={value}></button>
        )
    }

    const colors = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
        "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
        "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
        "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
        "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
    const options = [
        [
            {
                className: "ql-size",
                options: ["small", "large", "huge"]
            }
        ],
        [
            { className: "ql-bold" }, { className: "ql-italic" }, { className: "ql-underline" }, { className: "ql-strike" }
        ],
        [
            {
                className: "ql-color",
                options: colors
            }
        ]
    ];
    
	useEffect(() => {	
        const quillEditor = quillRef?.current?.getEditor();

        if (quillEditor != null) {
            setRawCharacterCount(getCharacterCount(quillEditor.getText().trimEnd()));
        }
	}, [content]);
   
    function handleContentChange(value) {
        const quillEditor = quillRef?.current?.getEditor();

        if (quillEditor == null) {
            setRawCharacterCount(0);
            return;
        }

        const currentLength = getCharacterCount(quillEditor.getText().trimEnd());

        quillEditor.on('text-change', function () {
            if (currentLength > maxAnnouncementCharacterCount) {
                quillEditor.deleteText(maxAnnouncementCharacterCount, currentLength);    
            }
        });

        if (previousState.content !== null) {
            setHasPendingChange(previousState.content !== value);
        } else {
            setPreviousState(prev => ({ ...prev, content: value }));
        }
        setContent(value);
    }

    function getCharacterCount(value) {     
        if(!value) {
            return 0;
        }

        const rawText = value.replace(/\r\n/g, '\n');
        return rawText.length;
    }

    return (
        <>
            <div id="toolbar">
                {
                    options.map((classes, i) => {
                        return (
                            <span key={`toolbar_${i}`} className="ql-formats">
                                {
                                    classes.map((formatData, j) => {
                                        return formatData.options ? renderOptions(formatData, j) : renderSingle(formatData, j)
                                    })
                                }
                            </span>
                        )
                    })
                }
            </div>
            <ReactQuill
                theme="snow"
                ref={quillRef}
                value={content}
                onChange={handleContentChange}
                style={{ height: '300px', marginBottom: '1rem' }}
                modules={modules}
            />
            <div className="form-check-label type-14 grey-dark-3 text-end">{rawCharacterCount}/{maxAnnouncementCharacterCount}</div>
        </>
    );
}

export default TextEditor;